<template>
    <div class="app">
      <div class="part1">
        <div class="img">
          <img src="@/assets/images/s.png">
        </div>
        <div>
          <div class="title">{{stitle}}</div>
          <div class="font2">
            <h3 class="mb11">如遇其他问题请电话咨询我们：0357-16465401  0357-16465401</h3>
            <p>服务时间：周一到周五 AM 5:00-PM 19:00</p>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="btn">查看订单</div>
        <div class="btn">返回首页</div>
        <div class="btn">{{btnmsg}}</div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "SuccessPop",
        props:{
          stitle:{
            type:String,
            default:'张三'
          },
          btnmsg:{
            type:String,
            default:'下载合同'
          }
        }
    }
</script>

<style scoped>
	.mb11{
		margin-bottom: 11px;
	}
.app{
  width: 996px;
  /*height: 297px;*/
  background: #fff;
  box-shadow: rgba(0,0,0,0.05) 0px 0px 5px 5px;
  margin: 0 auto;
  padding: 43px 38px 28px 57px;
  box-sizing: border-box;
}
  .part1{
    padding-bottom: 52px;
    border-bottom: 1px solid #E2E2E2;
    display: flex;
    box-sizing: border-box;
  }
  .img{
    width: 50px;
    height: 50px;
    margin-right: 23px;
  }
  img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .title{
    padding-top: 10px;
    color: #1A1A1A;
    font-size: 24px;
    text-align: left;
    box-sizing: border-box;
    font-weight: bold;
  }
  .font2 ,h3{
    font-size: 14px;
    color: #666666;
    text-align: left;
    padding-top: 26px;
  }
  .btns{
    padding: 26px 0 0 94px;
    box-sizing: border-box;
    display: flex;
  }
  .btn{
    width: 180px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    background: #fff;
    border: 1px solid #E2E2E2;
    color: #0875CD;
    margin-left: 16px;
  }
  .btn:first-child{
    background-image: linear-gradient(#3F9FEA, #0573CB);
    border-radius: 2px;
    color: #fff;
    font-weight: bold;
    border:0;
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/popBox/SuccessPop.vue